import React from "react";
import { Table } from "lucide-react";
import { Trans } from "react-i18next";
import i18n from "@/i18n";

import useUserComm from "@/hooks/notifications/useUserComm";
import useSendEmailJobRecipientPlaceholderValues from "@/hooks/notifications/useSendEmailJobRecipientPlaceholderValues";

import LoadingPanel from "@/components/loadingPanel";
import Alert from "@/components/alert";
import { Button } from "@/components/ui/button";

const { t } = i18n;

const UserCommRecipientPlaceholderValuesAlert = ({
  userCommId,
  editor,
  onClick,
}) => {
  const { data: userCommQuery } = useUserComm(userCommId);
  const userComm = userCommQuery?.data;
  const recipients = userComm?.recipients;

  const { isLoading, missingPlaceholderValuesCount, placeholdersUsed } =
    useSendEmailJobRecipientPlaceholderValues(recipients, editor);

  if (isLoading) {
    return <LoadingPanel />;
  }

  const hasAllPlaceholderValues = missingPlaceholderValuesCount === 0;

  if (placeholdersUsed.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full">
      <Alert
        variant={hasAllPlaceholderValues ? "success" : "warning"}
        title={
          hasAllPlaceholderValues
            ? t(
                "send_email_jobs.placeholder_status.no_missing_placeholder_values.title",
              )
            : t(
                "send_email_jobs.placeholder_status.missing_placeholder_values.title",
              )
        }
        message={
          hasAllPlaceholderValues ? (
            t(
              "send_email_jobs.placeholder_status.no_missing_placeholder_values.body",
            )
          ) : (
            <Trans
              i18nKey="send_email_jobs.placeholder_status.missing_placeholder_values.body"
              values={{ count: missingPlaceholderValuesCount }}
            />
          )
        }
        slot={
          <Button variant="secondary" onClick={onClick}>
            <Table size={16} />
            {hasAllPlaceholderValues
              ? t("send_email_jobs.placeholder_status.view_placeholder_values")
              : t("send_email_jobs.placeholder_status.view_issues", {
                  count: missingPlaceholderValuesCount,
                })}
          </Button>
        }
      />
    </div>
  );
};

export default UserCommRecipientPlaceholderValuesAlert;
